import React, { useEffect, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { Container, Paper, Typography, Alert, Button, CircularProgress, Box } from '@mui/material';
import apiService from '../../services/apiService';
import { API_ENDPOINTS } from '../../config/api';

// Szolgáltatói meghívó elutasítása ("nem kérem" link a meghívó emailben): megerősítés után
// végleg töröljük a szolgáltatónak előkészített fiókot. Szándékosan gombnyomásra (POST) töröl,
// hogy egy levelezőrendszer link-előnézete ne indíthassa el.
const DeclineProviderInvite = () => {
  // Az útvonalas link az elsődleges; a korábban kiküldött ?token= linkek is működnek maradnak
  const { token: pathToken } = useParams();
  const [searchParams] = useSearchParams();
  const token = pathToken || searchParams.get('token');
  const [status, setStatus] = useState(token ? 'loading' : 'error'); // loading | confirm | deleting | done | error
  const [message, setMessage] = useState(token ? '' : 'Hiányzó vagy érvénytelen link.');
  const [businessName, setBusinessName] = useState('');

  useEffect(() => {
    if (!token) return;
    apiService.get(API_ENDPOINTS.AUTH.PROVIDER_INVITE_DECLINE_INFO(token))
      .then((response) => {
        setBusinessName(response?.data?.businessName || '');
        setStatus('confirm');
      })
      .catch((err) => {
        setMessage(err?.message || 'Ez a meghívó már nem érvényes.');
        setStatus('error');
      });
  }, [token]);

  const handleDecline = async () => {
    setStatus('deleting');
    try {
      await apiService.post(API_ENDPOINTS.AUTH.PROVIDER_INVITE_DECLINE, { token });
      setStatus('done');
    } catch (err) {
      setMessage(err?.message || 'Hiba történt. Kérjük, próbáld újra, vagy írj a hello@wedigo.hu címre.');
      setStatus('error');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>Meghívó elutasítása</Typography>

        {status === 'loading' && <CircularProgress sx={{ my: 3 }} />}

        {(status === 'confirm' || status === 'deleting') && (
          <>
            <Typography variant="body1" sx={{ my: 3 }}>
              Biztosan nem szeretnél megjelenni a Wedigo esküvői piactéren? A gombra kattintva véglegesen
              töröljük a(z) <strong>{businessName}</strong> számára előkészített fiókot és minden hozzá tartozó
              adatot, és többet nem keresünk meg.
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Button
                variant="contained"
                color="error"
                onClick={handleDecline}
                disabled={status === 'deleting'}
              >
                {status === 'deleting' ? <CircularProgress size={22} color="inherit" /> : 'Nem kérem, töröljétek az adatokat'}
              </Button>
              <Button component={Link} to="/reszletek" variant="outlined" disabled={status === 'deleting'}>
                Mégis megnézem, mit kínáltok
              </Button>
            </Box>
          </>
        )}

        {status === 'done' && (
          <>
            <Alert severity="success" sx={{ my: 3, textAlign: 'left' }}>
              Töröltük a(z) {businessName} számára előkészített fiókot és adatokat. Többet nem keresünk meg ezzel a meghívóval.
              Ha később mégis csatlakoznál, bármikor regisztrálhatsz.
            </Alert>
            <Button component={Link} to="/" variant="contained">Vissza a főoldalra</Button>
          </>
        )}

        {status === 'error' && (
          <>
            <Alert severity="warning" sx={{ my: 3, textAlign: 'left' }}>{message}</Alert>
            <Button component={Link} to="/" variant="contained">Vissza a főoldalra</Button>
          </>
        )}
      </Paper>
    </Container>
  );
};

export default DeclineProviderInvite;
